Vue.component("webinar-on-demand-checkout", {
    props: {
        video: {
            required: true
        },
        user: {
            required: true
        },
        donations: {
            required: false,
            default: false
        },
        usedcoupon: {
            required: false
        },
        scriptendpoint: ""
    },

    data: function() {
        return {
            redirect_form_key: [],
            used_coupon_discount: 0,
            promo_code_id: 0,
            instantlink: "",
            payment_token: "",
            instant_eft_success: false,
            forms: {
                webinarCheckout: $.extend(
                    true,
                    new AppForm({
                        busy: false,
                        donations: 0,
                        paymentOption: "",
                        card: null,
                        terms: false
                    }),
                    App.forms.webinarCheckout
                )
            },
            addingNewCard: false,
            newcard: {
                number: "",
                holder: "",
                exp_month: "",
                exp_year: "",
                cvv: "",
                return: "",
                errors: []
            },
            threeDs: {
                url: "",
                connector: "",
                MD: "",
                TermUrl: "",
                PaReq: ""
            },
            readyForThreeDs: false,
            checkoutId: null,
            entityId: null
        };
    },

    computed: {
        total: function() {
            if (
                this.video.black_friday_discounts &&
                this.video.black_friday_price > 0
            ) {
                var amount = this.video.black_friday_price;
            } else {
                var amount = this.video.amount;
            }
            var donation = this.getDonations();
            var total =
                parseFloat(amount) +
                parseFloat(donation) -
                parseFloat(this.used_coupon_discount);
            return total;
        }
    },

    created() {
        if (
            this.usedcoupon != null &&
            this.usedcoupon != "" &&
            this.usedcoupon != undefined
        ) {
            this.promo_code_id = this.usedcoupon.id;
      if (this.usedcoupon.discount_type == 'percentage') {
     
                    this.used_coupon_discount =
          (this.video.amount * this.usedcoupon.discount_amount) / 100;
        
    
            } else {
                this.used_coupon_discount = this.usedcoupon.discount_amount;
            }
        }
    },

    ready: function() {
        window.addEventListener("message", event => {
            if (typeof event.data == "string") {
                try {
                    eval(event.data);
                    setTimeout(() => {
                        this.forms.webinarCheckout.busy = false;
                        swal.close();
                    }, 2000);
                } catch (e) {
                    this.forms.webinarCheckout.busy = false;
                    // swal.close()
                }
            }
        });
    },

    mounted() {
        this.loadPeachScript();
    },

    methods: {
        loadPeachScript: function() {
            return new Promise((resolve, reject) => {
                if (window.Checkout) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = this.scriptendpoint;
                script.onload = resolve;
                script.onerror = reject;

                document.head.appendChild(script);
            });
        },

        closeModal() {
            $("#checkout_model").modal("hide");
            this.checkoutId = null;
        },

        handleSuccess(event) {
            this.closeModal();
        },
        popEft() {
            if (!this.validate()) {
                return;
            }
            this.process();
            this.forms.webinarCheckout.busy = true;
            this.getEftLink();
        },

        /**
         * Add New Card
         */
        addCard() {
            this.newcard.return = `/webinars_on_demand/checkout/${this.video.slug}?threeDs=yes`;

            this.processPayment();

            this.$http
                .post("/account/billing", this.newcard)
                .then(response => {
                    if (
                        response.data.redirect === undefined ||
                        response.data.redirect === null
                    ) {
                        this.saveCard(response.data.id);
                        this.addingNewCard = false;
                    } else {
                        this.threeDs.url = response.data.redirect.url;
                        for (
                            var i =
                                response.data.redirect.parameters.length - 1;
                            i >= 0;
                            i--
                        ) {
                            this.redirect_form_key.push({
                                form_key:
                                    response.data.redirect.parameters[i].name,
                                form_value:
                                    response.data.redirect.parameters[i].value
                            });
                            this.threeDs[
                                response.data.redirect.parameters[i].name
                            ] = response.data.redirect.parameters[i].value;
                        }
                        this.readyForThreeDs = true;
                        swal.close();
                    }
                })
                .catch(errors => {
                    this.newcard.errors = errors.data;
                    swal.close();
                });
        },

        /**
         * Save User Card
         */
        saveCard(id) {
            this.$http
                .post("/account/billing/card", { id: id })
                .then(response => {
                    this.user.cards.push(response.data.card);
                    this.forms.webinarCheckout.card = response.data.card.id;
                    swal.close();
                })
                .catch(errors => {
                    if (errors.number) {
                        swal({
                            type: "error",
                            title: "Whoops",
                            text: errors.number
                        });
                    }
                });
        },

        cancelPayment: function() {
            this.forms.webinarCheckout.busy = false;
        },

        getEftLink: async function() {
            this.processPayment();
            this.showModal = true;
            await this.loadPeachScript();

            let data = {
                video: this.video.id,
                donation_amount: this.getDonations(),
                is_black_friday: 0
            };

            this.$http
                .post("/instant-eft", data)
                .then(async response => {
                    const res = response.data;

                    if (!res.checkoutId || !res.entityId) {
                        return;
                    }

                    this.checkoutId = res.checkoutId;
                    this.entityId = res.entityId;

                    await this.$nextTick();

                    $("#checkout_model").modal("show");

                    setTimeout(() => {
                        swal.close();
                        this.initCheckout();
                    }, 300);
                })
                .catch(error => {
                    let message = "Unable to process your request!";

                        if (error.status == 422) {
                            message = error.data.message;
                        }

                        swal({
                            type: "warning",
                            title: "Error",
                            text: message,
                            showConfirmButton: true
                        });

                    this.forms.webinarCheckout.busy = false;
                    return;
                });
        },

        initCheckout: function() {
            const checkout = window.Checkout.initiate({
                key: this.entityId,
                checkoutId: this.checkoutId,

                options: {
                    theme: {
                        brand: {
                            primary: "#ff0000"
                        },
                        cards: {
                            background: "#00ff00",
                            backgroundHover: "#F3F3F4"
                        }
                    },

                    paymentMethods: {
                        include: [
                            "CARD",
                            "OZOW",
                            "MASTERPASS",
                            "MOBICRED",
                            "PAYFLEX",
                            "1FORYOU",
                            "PAYSHAP",
                            "PAYBYBANK",
                            "CAPITECPAY",
                            "NEDBANKDIRECTEFT",
                            "ABSAEFT",
                            "PEACHEFT"
                        ]
                    },

                    ordering: {
                        OZOW: 1,
                        CARD: 2,
                        MASTERPASS: 3,
                        MOBICRED: 4,
                        PAYFLEX: 5,
                        "1FORYOU": 6,
                        PAYSHAP: 7,
                        PAYBYBANK: 8,
                        CAPITECPAY: 9,
                        NEDBANKDIRECTEFT: 10,
                        ABSAEFT: 11,
                        PEACHEFT: 12
                    }
                },

                events: {
                    onCompleted: event => {
                        const resultCode = event.result.code || "";

                        const message =
                            event.result.description ||
                            "Payment response received";

                        const isSuccess = /^(000\.000\.|000\.100\.1|000\.[36]|000\.400\.[1][12]0)/.test(
                            resultCode
                        );

                        if (isSuccess) {
                            swal({
                                type: "success",
                                title: "Payment Successful",
                                text: message,
                                showConfirmButton: true
                            });
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            swal({
                                type: "error",
                                title: "Payment Failed",
                                text: message,
                                showConfirmButton: true
                            });

                            this.forms.webinarCheckout.busy = false;
                            return;
                        }
                    },
                    onCancelled: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text: "Your Payment has Cancelled, please try again"
                        });
                        swal.close();
                        this.forms.webinarCheckout.busy = false;
                    },
                    onExpired: event => {
                        swal({
                            type: "error",
                            title: "Error",
                            text:
                                "Your Payment has Session Expired, please try again"
                        });
                        swal.close();
                        this.forms.webinarCheckout.busy = false;
                    }
                }
            });

            checkout.render("#payment-form");
        },

        startListener: function() {
            var pusher = new Pusher("5e9e56a5a0ebaf5484b0", {
                cluster: "mt1"
            });

            var channel = pusher.subscribe("instantefts");

            channel.bind(
                "App\\Events\\InstantEftNotificationReceived",
                data => {
                    if (this.payment_token == data.payment_key) {
                        if (data.success === true) {
                            this.process();
                            this.instant_eft_success = true;
                            this.sendRegistration();
                        } else {
                            this.cancelPayment();
                            swal({
                                type: "error",
                                title: "Error",
                                text:
                                    "Your Payment has failed, please try again"
                            });
                        }
                    }
                }
            );
        },

        process: function() {
            swal({
                title: "",
                text:
                    '<i id="busy" class="fa fa-spinner fa-pulse" style="font-size: 8em; color: #ffffff;"></i>',
                html: true,
                allowEscapeKey: false,
                allowOutsideClick: false,
                showCancelButton: false,
                showConfirmButton: false,
                closeOnCancel: false,
                customClass: "no-bg"
            });
        },

        register: function() {
            this.forms.webinarCheckout.errors.forget();
            this.forms.webinarCheckout.busy = true;
            //this.process();
            this.sendRegistration();
        },
        processPayment: function() {
            swal({
                type: "warning",
                title: "Payment Processing",
                text:
                    "Please wait while we are processing your payment.Do not Refresh page or close browser"
            });
        },
        
        beginCheckout: function () {
   
            window.dataLayer = window.dataLayer || [];

            var items = [];

            items.push({
                item_id: String(this.video.id),
                item_name: this.video.title,
                item_category: "Webinars on demand",
                price: parseFloat(parseFloat(this.total).toFixed(2)),
                quantity:  1
            });

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    value: parseFloat(parseFloat(this.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        sendTransactions: function (invoice) {

            window.dataLayer = window.dataLayer || [];
            
            var items = [];

            if (invoice.items && invoice.items.length > 0) {
                invoice.items.forEach(function (item) {
                    items.push({
                        item_id: String(item.item_id),
                        item_name: item.name,
                        item_category: "Webinars on demand",
                        price: parseFloat(parseFloat(item.price).toFixed(2)),
                        quantity: item.quantity
                    });
                });
            }

            window.dataLayer.push({ ecommerce: null });

            window.dataLayer.push({
                event: "purchase",
                ecommerce: {
                    transaction_id: invoice.reference,
                    value: parseFloat(parseFloat(invoice.total).toFixed(2)),
                    currency: "ZAR",
                    items: items
                },
                payment_method: this.getPaymentMethod() || undefined,
                payment_status: invoice.paid == 1 ?  "successful" : "failed",
                email: this.user.email || undefined,
                cell: this.user.cell || undefined,
            });
        },

        getPaymentMethod:function(){
          
            if(this.forms.webinarCheckout.paymentOption == 'cc'){
              return  'Credit Card';
            }  
            
            if(this.forms.webinarCheckout.paymentOption == 'eft'){
              return  'Instant EFT';
            }  

            return "";
        },

        sendRegistration: function() {
            if (!this.validate()) {
                return;
            }
            if (
                this.forms.webinarCheckout.paymentOption == "eft" &&
                this.instant_eft_success == false
            ) {
                this.forms.webinarCheckout.busy = true;
                return;
            }

            if (
                this.forms.webinarCheckout.paymentOption == "cc" &&
                !this.forms.webinarCheckout.card
            ) {
                swal({
                    type: "warning",
                    title: "Error",
                    text:
                        "Unable to purchase without credit card, please select credit card"
                });
                this.forms.webinarCheckout.busy = false;
                return;
            }

            var payload = {
                video: this.video.id,
                terms: this.forms.webinarCheckout.terms,
                card: this.forms.webinarCheckout.card,
                paymentOption: this.forms.webinarCheckout.paymentOption,
                donations: this.getDonations(),
                promo_code_id: this.promo_code_id,
            };

            this.processPayment();
            this.beginCheckout();

            this.$http
                .post(
                    "/webinars_on_demand/checkout/" +
                        this.video.slug +
                        "/complete",
                    payload
                )
                .success(function(response) {
                    this.forms.webinarCheckout.busy = false;
                    swal.close();
                    if (response.invoice !== undefined) {
                        this.sendTransactions(response.invoice);
                    }
                    window.location = "/dashboard/webinars_on_demand";
                })
                .error(function(errors) {
                    this.forms.webinarCheckout.busy = false;
                    swal.close();
                    if (errors) {
                        this.forms.webinarCheckout.errors.set(errors);
                    }
                });
        },

        total: function(){
            var donation = this.getDonations();
            var amount = 0;
            if (this.video.black_friday_discounts && this.video.black_friday_price > 0) {
                amount = this.video.black_friday_price;
            } else {
                amount = this.video.amount;
            }

            return  amount + donation;
        },


        /*
         * Calculate the donation
         */
        getDonations: function() {
            var total = 0;
            if (this.forms.webinarCheckout.donations) {
                total = this.donations;
            }
            return total;
        },

        validate: function() {
            if (this.forms.webinarCheckout.donations) {
                if (
                    !this.id_number ||
                    !this.id_type ||
                    !this.country_of_issue ||
                    !this.incometax_reference_number ||
                    !this.date_of_birth ||
                    !this.post_code ||
                    !this.postal_address
                ) {
                    swal({
                        type: "error",
                        title: "Donation Details Required",
                        text:
                            "Please complete all donation fields before proceeding."
                    });
                    this.forms.webinarCheckout.busy = false;
                    return false;
                }
            }

            if (!this.forms.webinarCheckout.terms) {
                swal({
                    type: "warning",
                    title: "Error",
                    text: "Please accept terms and conditions to process"
                });
                this.forms.webinarCheckout.busy = false;
                return false;
            }

            return true;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/webinar_on_demand/checkout.js